import { Link, styled } from '@driftt/dds'

export const StyledLink = styled(Link, {
  width: '200px',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  display: 'block',
})
